import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetAgencyOwnersResponseTO } from 'models/Owner';
import API from 'services/API';

export const AGENCY_OWNERS_BASE_QUERY_KEY = 'agencyOwners';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetAgencyOwnersResponseTO>,
  'queryKey' | 'queryFn'
>;

type useAgencyOwnersArgs = {
  agencyUid: string;
} & ReactQueryOptions;

const useAgencyOwners = ({
  agencyUid,
  enabled = true,
  ...options
}: useAgencyOwnersArgs) => {
  return useAppQuery<GetAgencyOwnersResponseTO>({
    queryKey: [AGENCY_OWNERS_BASE_QUERY_KEY, 'detail', agencyUid],
    queryFn: async () => {
      const response = await API.get<GetAgencyOwnersResponseTO>(
        `/api/v3.2/owners?agencyUid=${agencyUid}`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...(options ?? {}),
  });
};

export default useAgencyOwners;
